import { Pad } from 'component/basics';
import { UtilityText } from 'component/text';
import type { CommentWithEntryPoints } from 'feature/question/context-entry-points';
import { ComposerEntryPointCard, PostedCommentEntryPointCard } from 'feature/question/context-entry-points';
import { HelpIfDifferentUrl } from 'feature/question/single-response-help';
import React, { useState } from 'react';
import { View } from 'react-native';
import { CLICK, component, demoFile, story } from 'system/demo';
import { makeAssetUrl, urlToKey } from 'util/util';

demoFile('feature/question/context-entry-points');

const articleTitle = 'Title of article that the comment author was reading when they posted the comment';

const initialComment = {
    key: '1',
    from: 'a',
    time: Date.now(),
    text: 'hi',
    entryUrl: 'https://google.com',
};

const mockGlobalParams = {
    entryUrl: makeAssetUrl('https://google.com'),
};

const mockModulePublic = {
    article: {
        articleInfo: {
            [urlToKey('https://google.com')]: { title: articleTitle, image: makeAssetUrl('images/bubbles.png') },
        },
    },
};

function ComposerContextEntryPointWrapper() {
    const [comment, setComment] = useState<CommentWithEntryPoints>(initialComment);
    return <ComposerEntryPointCard comment={comment} setComment={setComment} />;
}

// Composer View
const ComposerViewDemo = ComposerContextEntryPointWrapper;
component(
    'Composer View',
    ComposerViewDemo,
    {
        args: { comment: initialComment },
        state: {
            globalParams: mockGlobalParams,
            modulePublic: mockModulePublic,
        },
    },
    [story('Remove Article', [CLICK('Do not associate the source article with your response')])],
);

// Posted Comment View
const PostedCommentViewDemo = PostedCommentEntryPointCard;
component('Posted Comment View', PostedCommentViewDemo, {
    args: { comment: initialComment },
    state: {
        globalParams: mockGlobalParams,
        modulePublic: mockModulePublic,
    },
});

// Single Response Help - different URL
const SingleResponseHelpDifferentURLDemo = () => (
    <View>
        <HelpIfDifferentUrl comment={{ key: '1', from: 'a', time: Date.now(), text: 'hi', entryUrl: 'https://bar.com' }} />
        <Pad size={80} />
    </View>
);
component('Single Response Help - different URL', SingleResponseHelpDifferentURLDemo, {
    state: {
        globalParams: { entryUrl: 'https://foo.com' },
    },
});

// Single Response Help - same URL
const SingleResponseHelpSameURLDemo = () => (
    <View>
        <HelpIfDifferentUrl comment={{ key: '1', from: 'a', time: Date.now(), text: 'hi', entryPoints: [{ url: 'https://bar.com' }] }} />
        <UtilityText text='No help bubble should be displayed' />
    </View>
);
component('Single Response Help - same URL', SingleResponseHelpSameURLDemo, {
    state: {
        globalParams: { entryUrl: 'https://bar.com' },
    },
});
